/* ALFA · rotación de productos por visita
   Un contenedor [data-rotar="N"] con hijos [data-rot-item] muestra N por vez.
   Cada visita nueva (no cada página) corre la ventana N lugares: con 16 y N=8,
   la primera visita ve 1-8, la segunda 9-16, la tercera 1-8 otra vez. Si la
   cuenta no cierra, da la vuelta (los dos últimos y los dos primeros). Dentro de
   la misma visita la selección no cambia mientras se navega. */
(() => {
  let visita = 0;
  try {
    visita = parseInt(localStorage.getItem("alfa:visitas") || "0", 10) || 0;
    if (!sessionStorage.getItem("alfa:visita-contada")) {
      visita += 1;
      localStorage.setItem("alfa:visitas", String(visita));
      sessionStorage.setItem("alfa:visita-contada", "1");
    }
  } catch {
    visita = Math.floor(Math.random() * 100);
  }
  const rotar = (root) => {
    const n = parseInt(root.dataset.rotar, 10) || 8;
    const items = [...root.querySelectorAll(":scope > [data-rot-item]")];
    if (items.length <= n) { items.forEach((el) => el.removeAttribute("data-rot-oculto")); return; }
    const inicio = (visita * n) % items.length;
    const ver = new Set();
    for (let k = 0; k < n; k++) ver.add((inicio + k) % items.length);
    const orden = [...ver];
    items.forEach((el, i) => {
      const pos = orden.indexOf(i);
      if (pos === -1) el.setAttribute("data-rot-oculto", "");
      else { el.removeAttribute("data-rot-oculto"); el.style.order = String(pos); }
    });
    root.classList.add("is-rotado");
  };
  const todo = () => document.querySelectorAll("[data-rotar]").forEach(rotar);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", todo);
  else todo();
})();
